module.exports = __webpack_public_path__ + "2948a07f18ba02b899d9a43d179938a6.png";